import { useState } from "react";
import { useSupabase } from "../supabaseClient";
import { C } from "../constants/colors";

// Supabase schema needed:
// CREATE TABLE testimonials (
//   id uuid DEFAULT gen_random_uuid() PRIMARY KEY,
//   clerk_user_id text NOT NULL,
//   stars integer CHECK (stars BETWEEN 1 AND 5),
//   response text,
//   trigger text,  -- 'offer_review' or 'blueprint_gate'
//   created_at timestamptz DEFAULT now()
// );

export function ReviewWidget({ userId, onSubmitted, trigger = "offer_review" }) {
  const getSupabase = useSupabase();
  const [stars, setStars] = useState(0);
  const [hovered, setHovered] = useState(0);
  const [response, setResponse] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!stars) return;
    setSubmitting(true);
    try {
      const sb = await getSupabase();
      await sb.from("testimonials").insert({
        clerk_user_id: userId,
        stars,
        response: response.trim() || null,
        trigger,
      });
    } catch (err) {
      console.error("Failed to save testimonial:", err);
    }
    setSubmitted(true);
    setSubmitting(false);
    onSubmitted?.();
  };

  if (submitted) {
    return (
      <div style={{ margin: "12px 0", padding: "14px 16px", background: `${C.teal}14`, borderRadius: 12, border: `1px solid ${C.teal}33`, textAlign: "center" }}>
        <div style={{ fontSize: 18, marginBottom: 4 }}>⭐⭐⭐⭐⭐</div>
        <p style={{ margin: 0, fontSize: 12, color: C.teal, fontWeight: 600 }}>Thank you — this means a lot.</p>
      </div>
    );
  }

  return (
    <div style={{ margin: "12px 0", padding: "16px", background: "#fff", borderRadius: 12, border: "1px solid #e8e8f0", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
      <p style={{ margin: "0 0 10px", fontSize: 12, color: C.indigo, fontWeight: 600 }}>How would you rate your experience so far?</p>
      <div style={{ display: "flex", gap: 6, marginBottom: 12 }}>
        {[1, 2, 3, 4, 5].map((n) => (
          <button key={n}
            onClick={() => setStars(n)}
            onMouseEnter={() => setHovered(n)}
            onMouseLeave={() => setHovered(0)}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 22, padding: 2, opacity: (hovered || stars) >= n ? 1 : 0.3, transition: "opacity 0.1s" }}
          >⭐</button>
        ))}
      </div>
      <textarea
        value={response}
        onChange={e => setResponse(e.target.value)}
        placeholder="What has working through this made possible for you that wasn't possible before? (optional)"
        style={{ width: "100%", resize: "none", border: "1.5px solid #e0dfe8", borderRadius: 8, padding: "9px 11px", fontSize: 16, fontFamily: "inherit", lineHeight: 1.5, minHeight: 72, outline: "none", boxSizing: "border-box" }}
        rows={3}
      />
      <button
        onClick={handleSubmit}
        disabled={!stars || submitting}
        style={{
          marginTop: 8, width: "100%", padding: "9px", borderRadius: 8, border: "none",
          background: stars ? C.teal : "#ccc", color: "#fff", fontSize: 12, fontWeight: 600,
          cursor: stars ? "pointer" : "not-allowed", transition: "background 0.15s",
        }}
      >
        {submitting ? "Saving…" : "Submit"}
      </button>
    </div>
  );
}
